import React, { Fragment, useState, useEffect } from "react";
import MarketplaceVouchersServices from "../../../apis/Marketplace/Vouchers/MarketplaceVoucherServices";
import { PrimaryButton } from "../../../components/Button/Button";
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import { useForm } from "react-hook-form";
import colors from "../../../styles/colors";
import { InputField } from "../../../components/Fields/TextField";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ErrorToaster,
  SuccessToaster,
} from "../../../components/Toaster/Toaster";
import {
  Box,
  Grid,
  Typography,
  FormControlLabel,
  FormLabel,
  Switch,
} from "@mui/material";

function EditMVoucher() {
  const [loading, setLoading] = useState(false);
  const [discountValue, setDiscountValue] = useState("");
  const [selectedDiscount, setSelectedDiscount] = useState(false);
  const { state } = useLocation();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();
  const currentDate = new Date().toISOString().split("T")[0];

  const defaultData = () => {
    setValue("code", state?.data?.code);
    setDiscountValue(
      state?.data?.discount_percent === 0
        ? state?.data?.discount_amount
        : state?.data?.discount_amount === 0
          ? state?.data?.discount_percent
          : null
    );
    setValue("minimumAmount", state?.data?.minimum_amount);
    setValue("usageLimit", state?.data?.usage_limit);
    const formattedFromDate = new Date(state?.data?.valid_from)
      .toISOString()
      .split("T")[0];
    setValue("validFrom", formattedFromDate);
    const formattedToDate = new Date(state?.data?.valid_to)
      .toISOString()
      .split("T")[0];
    setValue("validTo", formattedToDate);
    setValue("usageLimitPerCx", state?.data?.usage_limit_user);
    setSelectedDiscount(state?.data?.discount_percent > 0 ? false : true);
  };

  const createVoucher = async (formData) => {
    setLoading(true);
    try {
      const minimumAmount = parseFloat(formData.minimumAmount);
      let obj = {
        code: formData.code,
        discount_amount: selectedDiscount === true ? discountValue : 0,
        discount_percent: selectedDiscount === true ? 0 : discountValue,
        valid_from: formData.validFrom,
        valid_to: formData.validTo,
        usage_limit: formData.usageLimit,
        minimum_amount: minimumAmount,
        usage_limit_user: formData.usageLimitPerCx
      };
      const result = await MarketplaceVouchersServices.updateVoucher(
        state?.data?._id,
        obj
      );
      const { data, message } = result;
      if (data === null) return;
      SuccessToaster(message);
      setTimeout(() => navigate("/marketplace/vouchers"), 1000);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    defaultData();
  }, []);

  return (
    <Fragment>
      <Box
        sx={{
          backgroundColor: colors.lightGray,
          p: 3,
          borderRadius: "12px",
          // width: "calc(100vw - 370px)",
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ bgcolor: colors.white, p: 2, borderRadius: "12px" }}
        >
          <Grid item xs={6}>
            <Typography variant="body1" fontWeight="bold" color="initial">
              Edit Voucher
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage={["Vouchers", "Edit Voucher"]} />
          </Grid>
        </Grid>

        <Box sx={{ bgcolor: colors.white, p: 3, borderRadius: "12px", mt: 2 }}>
          <Typography component={"form"} onSubmit={handleSubmit(createVoucher)}>
            <Grid container spacing={2} alignItems={"flex-end"}>
              <Grid item md={4}>
                <InputField disable={true} register={register("code")} />
              </Grid>
              <Grid item md={4}>
                <Grid container spacing={2} alignItems={"center"}>
                  <Grid item md={8}>
                    <InputField
                      value={discountValue}
                      label={
                        selectedDiscount === false
                          ? "Discount Percent"
                          : "Discount Amount"
                      }
                      register={register("discountValue", {
                        required:
                          discountValue === ""
                            ? "Please fill the field"
                            : false,
                      })}
                      onChange={(e) => setDiscountValue(+e.target.value)}
                      error={errors?.discountValue?.message}
                    />
                  </Grid>
                  <Grid item md={4} p={"0 !important"}>
                    <FormControlLabel
                      control={
                        <Switch
                          defaultChecked={
                            state?.data?.discount_percent > 0 ? false : true
                          }
                          onChange={(e) =>
                            setSelectedDiscount(e.target.checked)
                          }
                          sx={{ m: 1 }}
                        />
                      }
                      label={selectedDiscount ? "AED" : "Per%"}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={4}>
                <Grid container spacing={2}>
                  <Grid item md={6}>
                    <InputField
                      label="Usage Limit"
                      register={register("usageLimit", {
                        required: "Please fill the field",
                        pattern: {
                          value: /^[0-9]*$/,
                          message: "Please enter a valid numeric value",
                        },
                      })}
                      error={errors?.usageLimit?.message}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <InputField
                      label="Usage Limit Per Cx"
                      register={register("usageLimitPerCx", {
                        required: "Please fill the field",
                        pattern: {
                          value: /^[0-9]*$/,
                          message: "Please enter a valid numeric value",
                        },
                      })}
                      error={errors?.usageLimitPerCx?.message}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={4}>
                <FormLabel>Valid From</FormLabel>
                <InputField
                  type={"date"}
                  placeholder={"Valid From"}
                  register={register("validFrom", {
                    required: "Please fill the field",
                  })}
                  min={currentDate}
                  error={errors?.validFrom?.message}
                />
              </Grid>
              <Grid item md={4}>
                <FormLabel>Valid To</FormLabel>
                <InputField
                  type={"date"}
                  placeholder={"Valid To"}
                  register={register("validTo", {
                    required: "Please fill the field",
                  })}
                  error={errors?.validTo?.message}
                  min={currentDate}
                />
              </Grid>
              <Grid item md={4}>
                <InputField
                  label="Minimum Amount"
                  register={register("minimumAmount", {
                    required: "Please fill the field",
                  })}
                  error={errors?.minimumAmount?.message}
                />
              </Grid>
            </Grid>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PrimaryButton
                data-testId="save-btn"
                title={"Update"}
                type="submit"
                loading={loading}
              />
            </Box>
          </Typography>
        </Box>
      </Box>
    </Fragment>
  );
}

export default EditMVoucher;
